document.addEventListener('DOMContentLoaded', function() {
    let tabContainers = document.querySelectorAll('.regional-locations');
    if(!tabContainers) return;

    tabContainers.forEach((tabContainer) => {
        let tabSelectors = tabContainer.querySelectorAll('.region-tab-selector');
        let tabPanels = tabContainer.querySelectorAll('.region-tab-panel');

        tabSelectors.forEach((selector) => {
            selector.addEventListener('click', function() {
                let targetID = selector.dataset.trigger;
                
                tabSelectors.forEach((tsel) => {
                    tsel.classList.remove('active');
                })
                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                });

                selector.classList.toggle('active');
                tabContainer.querySelector(`.region-tab-panel[data-target="${targetID}"]`).classList.toggle('active');
            });
        });
    });
});